import { useEffect, useState } from 'react';

// transient sewer / storm water results shared between the AquaFlow panel and the map layer
let st = { res: null, on: false, view: { net: true, only: false, sew: true, river: true } };
const subs = new Set();
export const sewState = () => st;
export const setSew = (p) => { st = { ...st, ...p }; subs.forEach((f) => f(st)); };
export function useSew() {
  const [s, set] = useState(st);
  useEffect(() => { subs.add(set); return () => subs.delete(set); }, []);
  return s;
}
